import React, { useState, useEffect } from "react";
import NavBar from "../components/NavBar/Main.js"
import Footer from "../components/Footer/Main.js"
import axios from "axios";
import moment from 'moment';
import client from "../feathers.js"

var pattern = "0000";

const Summary = (props) => {
  const [ data, setData ] = useState({transactionData: {billingAddress: {}}})

  useEffect(() => {
    if(props.match.params.id){
      axios.get(`${client.io.io.uri}getSummary`,{
        params: {
          id: props.match.params.id
        },
      }).then(res => {
        setData(res.data[0])
      })
    }
  }, [props.match.params.id])

  return (  
    <>
      <NavBar />
      <main>
        {/* <div
          style={{
            backgroundImage: 'url(//cdn.shopify.com/s/files/1/3012/8606/t/4/assets/collection_top.jpg?v=13539636231063041806)', 
            position:'relative', 
            marginBottom: 100,
            minHeight: 530
          }}
        >
          <div className="breadcrumbs">
            <div className="container" style={{paddingRight: 60, paddingLeft: 60}}>
              <h1>Summary</h1>
              <ul className="breadcrumb" style={{display: 'block'}}>
                <li><a href="/" style={{color:'#fff'}}>
                    Home
                  </a>
                </li>
                <li>
                  <a href="/viewcart"><span>Summary</span></a>
                </li>
              </ul>
            </div>
          </div>
        </div> */}
        <div className="container" style={{marginBottom:100, paddingTop: 150}}>
          <section className="order_details section-margin--small">
            <div className="container">
              <h2 className="text-center mb-5">Thank You! Your order has been received.</h2>
              <div className="row mb-5">
                <div className="col-md-6 col-xl-4 mb-4 mb-xl-0">
                  <div className="well">
                    <h3 className="billing-title">Order Info</h3>
                    <table className="order-rable">
                      <tbody><tr>
                          <td>Order number</td>
                          <td>: {data?.invoicePrefix}
                            {(pattern + (data?.invoiceNumber || '')).slice(-4)}
                          </td>
                        </tr>
                        <tr>
                          <td>Date</td>
                          <td>: {moment(data.createdAt).format("MMM Do YYYY")}</td>
                        </tr>
                        <tr>
                          <td>Total</td>
                          <td>: {data.currency}{" "} 
                            {
                            data.currency === "USD"?
                            new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(data?.transactionData?.totalPaidAmount || data.totalAmount)
                            :
                            new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(data?.transactionData?.totalPaidAmount || data.totalAmount)
                            }
                          </td>
                        </tr>
                        <tr>
                          <td>Payment method</td>
                          <td>: {data?.transactionData?.paymentMethod ? (data.transactionData.paymentMethod).toUpperCase() : 'PAYPAL'}</td>
                        </tr>
                        <tr>
                          <td>Tracking Num.</td>
                          <td>: 
                            <span className="font-weight-bold">
                              {data?.trackingNumber ? data.trackingNumber : 'Tracking Number will be displayed once your item is shipped.'}
                            </span>
                          </td>
                        </tr>
                      </tbody></table>
                  </div>
                </div>
                <div className="col-md-6 col-xl-4 mb-4 mb-xl-0">
                  <div className="well">
                    <h3 className="billing-title">Billing Address</h3>
                    <table className="order-rable">
                      <tbody><tr>
                          <td>Street</td>
                          <td>: {data?.transactionData?.billingAddress?.address_line_1}</td>
                        </tr>
                        <tr>
                          <td>Region</td>
                          <td>: {data?.transactionData?.billingAddress?.admin_area_1}</td>
                        </tr>
                        <tr>
                          <td>Country</td>
                          <td>: {data?.transactionData?.billingAddress?.country_code}</td>
                        </tr>
                        <tr>
                          <td>Postcode</td>
                          <td>: {data?.transactionData?.billingAddress?.postal_code}</td>
                        </tr>
                      </tbody></table>
                  </div>
                </div>
                <div className="col-md-6 col-xl-4 mb-4 mb-xl-0">
                  <div className="well">
                    <h3 className="billing-title">Shipping Address</h3>
                    <table className="order-rable">
                      <tbody><tr>
                          <td>Street</td>
                          <td>: {data?.address}</td>
                        </tr>
                        <tr>
                          <td>Region</td>
                          <td>: {data?.state}</td>
                        </tr>
                        <tr>
                          <td>Country</td>
                          <td>: {data?.country}</td>
                        </tr>
                        <tr>
                          <td>Postcode</td>
                          <td>: {data?.postalCode}</td>
                        </tr>
                      </tbody></table>
                  </div>
                </div>
              </div>
              <div className="well">
                <h2>Order Details</h2>
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Product</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.purchaseItems?
                        data.purchaseItems.map((v, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                <p>{v.name}</p>
                              </td>
                              <td>
                                <h5>x {v.quantity}</h5>
                              </td>
                              <td>
                                <p>
                                  {
                                  data.currency === "USD"?
                                  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((v.totalNetAmount || 0) + (v.variations?.reduce((sum, va) => sum + (va.totalAmount || 0), 0) || 0))
                                  :
                                  new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format((v.totalNetAmountMYR || 0) + (v.variations?.reduce((sum, va) => sum + (va.totalAmountMYR || 0), 0) || 0))
                                  }
                                </p>
                              </td>
                            </tr>
                          )
                        })
                      :null}
                      <tr>
                        <td>
                          <h4>Subtotal</h4>
                        </td>
                        <td>
                        </td>
                        <td>
                          <p>
                            {
                            data.currency === "USD"?
                            new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(data.totalItemsAmount)
                            :
                            new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(data.totalItemsAmountMYR)
                            }
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h4>Shipping</h4>
                        </td>
                        <td>
                        </td>
                        <td>
                          <p>
                            {
                            data.currency === "USD"?
                            new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(data.shippingAmount)
                            :
                            new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(data.shippingAmountMYR)
                            }
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h4>Total</h4>
                        </td>
                        <td>
                        </td>
                        <td>
                          <h4>
                            {
                            data.currency === "USD"?
                            new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(data.totalAmount)
                            :
                            new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(data.totalAmountMYR)
                            }
                          </h4>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}
 
export default Summary;